import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {pageContent} from "../themes/utils";
import {Theme, ThemeProvider} from "@mui/material";
import { DefaultTheme} from "../themes/Default";

type PageLayoutProps = {
    children: React.ReactNode
}

const PageLayout: React.FC<PageLayoutProps> = ({children}) => {
    let theme: Theme = DefaultTheme;
    return (
        <Box>
            <ThemeProvider theme={theme}>
            <Header/>
            <Container maxWidth={false} sx={{minHeight: "100vh", maxWidth: "2500px"}}>
                <Box sx={{...pageContent(false)}}>
                    {children}
                </Box>
            </Container>
            <Footer/>
            </ThemeProvider>
        </Box>
    )
}

export default PageLayout;